import type { ServiceQueryOptionType } from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { AnnouncementDataType } from './types'

const QUERY_KEY = ['cms', 'announcement', 'active'] as const
const QUERY_KEY_LIST = ['cms', 'announcement', 'active-list'] as const

const getActive = (): ServiceQueryOptionType<AnnouncementDataType | null> => ({
  queryKey: QUERY_KEY,
  retry: 3,
  queryFn: async () => {
    try {
      const response = await api.get<{
        message: string
        data: AnnouncementDataType | null
      }>('/cms/announcement/active', { timeout: 30_000 })
      return response.data.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getActiveList = (): ServiceQueryOptionType<AnnouncementDataType[]> => ({
  queryKey: QUERY_KEY_LIST,
  retry: 3,
  queryFn: async () => {
    try {
      const response = await api.get<{
        message: string
        data: AnnouncementDataType | AnnouncementDataType[] | null
      }>('/cms/announcement/active', { timeout: 30_000 })
      const data = response.data.data
      if (!data) return []
      return Array.isArray(data) ? data : [data]
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const announcement = {
  getActive,
  getActiveList,
  QUERY_KEY,
  QUERY_KEY_LIST
}
